const pluralize = (word) => {
    // const vowels = 'aeiou';
    const irregulars = [
        'addenda', 'aircraft', 'alumnae', 'alumni', 'analyses', 'antennae',
        'antitheses', 'apices', 'appendices', 'axes', 'bacilli', 'bacteria',
        'bases', 'beaux', 'bison', 'bureaux', 'cacti', 'châteaux', 'children',
        'codices', 'concerti', 'corpora', 'crises', 'criteria', 'curricula',
        'data', 'deer', 'diagnoses', 'dice', 'dwarves', 'ellipses', 'errata',
        'faux pas', 'fezzes', 'fish', 'foci', 'feet', 'formulae', 'fungi',
        'genera', 'geese', 'graffiti', 'grouse', 'halves', 'hooves', 'hypotheses',
        'indices', 'larvae', 'libretti', 'loaves', 'loci', 'lice', 'men', 'matrices',
        'media', 'memoranda', 'minutiae', 'moose', 'mice', 'nebulae', 'nuclei', 'oases',
        'offspring', 'opera', 'ova', 'oxen', 'parentheses', 'phenomena', 'phyla', 'quizzes',
        'radii', 'referenda', 'salmon', 'scarves', 'selves', 'series', 'sheep', 'shrimp',
        'species', 'stimuli', 'strata', 'swine', 'syllabi', 'symposia', 'synopses', 'tableaux',
        'theses', 'thieves', 'teeth', 'trout', 'tuna', 'vertebrae', 'vertices', 'vitae', 'vortices',
        'wharves', 'wives', 'wolves', 'women', 'guys', 'buys', 'people',
    ];
    const irregular = Object.keys(irregulars).find((w) => w === word);
    if (irregular) {
        return irregular;
    }
    if (word[word.length - 1] === 's' || word.endsWith('sh') || word.endsWith('ch')
        || word[word.length - 1] === 'x' || word[word.length - 1] === 'z') {
        return `${word}es`;
    }
    if (word[word.length - 1] === 'y') {
        return `${word.substring(0, word.length - 1)}ies`;
    }
    return `${word}s`;
};
export default pluralize;
//# sourceMappingURL=pluralize.js.map